// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { findLocationModalStyles } from "@insite/content-library/Components/FindLocationModal";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color, mergeWithCss } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

findLocationModalStyles.searchButtonGridItem = {
    ...mergeWithCss(findLocationModalStyles.searchButtonGridItem, {
        css: css`
            display: flex;
            justify-content: end;
        `,
    }),
};

findLocationModalStyles.distanceUnitOfMeasureGridItem = {
    ...mergeWithCss(findLocationModalStyles.distanceUnitOfMeasureGridItem, {
        css: css`
            &&& {
                margin-top: 8px;
            }
        `,
    }),
};

findLocationModalStyles.siteMessageGridItem = {
    ...mergeWithCss(findLocationModalStyles.siteMessageGridItem, {
        css: css`
            &&& {
                margin-top: 8px;
            }
        `,
    }),
};

findLocationModalStyles.searchResultSelectButton = {
    variant: "primary",
    buttonType: "outline",
};

findLocationModalStyles.searchResultLinksOffsetGridItem = {
    width: 1,
    css: css`
        &&& {
            margin-right: 26px;
        }
    `,
};

findLocationModalStyles.searchResultSelectGridItem = {
    width: 3,
    css: css`
        justify-content: flex-end;
    `,
};

findLocationModalStyles.distanceUnitOfMeasureRadioGroup = {
    ...mergeWithCss(findLocationModalStyles.distanceUnitOfMeasureRadioGroup, {
        css: css`
            &&& {
                display: flex;
                flex-direction: row;
                align-items: baseline;
                justify-content: flex-end;
                gap: 16px;
            }
        `,
    }),
};

findLocationModalStyles.currentlySelectedHeaderText = {
    fontFamily: fontConfig.secondaryFontFamily,
    variant: "h4",
};

findLocationModalStyles.currentlySelectedGridContainer = {
    gap: 0,
};

findLocationModalStyles.currentlySelectedDetailsGridItem = {
    width: 12,
    css: css`
        padding-bottom: 12px;
    `,
};

findLocationModalStyles.searchResultGridItem = {
    width: 12,
    css: css`
        padding-top: 12px;
    `,
};

findLocationModalStyles.warehouseDistanceDisplayText = {
    ...fontConfig.smallSingleLine,
};

findLocationModalStyles.warehouseGoogleMapsDirectionLink = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
};
